var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMan2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 421.141 421.141",
    style: {
      enableBackground: "new 0 0 421.141 421.141"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE1B2"
    },
    d: "M121.521,176.024c-9.864-2.468-16.326,2.805-16.326,13.161c0,13.709,13.265,47.296,27.21,26.321 S121.521,176.024,121.521,176.024z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE1B2"
    },
    d: "M297.944,176.024c10.767-2.468,17.821,2.805,17.821,13.161c0,13.709-14.479,47.296-29.701,26.321 S297.944,176.024,297.944,176.024z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD7A3"
    },
    d: "M138.277,294.307c14.716-9.475,13.07-37.675,13.07-44.255h118.446c0,6.58-1.825,34.78,12.89,44.255 l-72.113,80.771L138.277,294.307z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDC88E"
    },
    d: "M256.632,322.436l26.051-28.129c-14.716-9.474-12.89-37.675-12.89-44.255H151.347 C159.845,274.485,216.054,316.404,256.632,322.436z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE1B2"
    },
    d: "M302.695,164.508c0,52.696-30.343,118.446-92.124,118.446s-92.124-65.75-92.124-118.446 s41.246-72.384,92.124-72.384S302.695,111.812,302.695,164.508z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A7795E"
    },
    d: "M300.536,145.31c-5.308-6.759-11.001-13.704-11.001-13.704v6.58 c1.645,59.634-19.741,85.544-19.741,85.544l-27.249,3.027c-21.251,2.361-42.697,2.361-63.948,0l-27.249-3.027 c0,0-21.386-25.91-19.741-85.544v-6.58c0,0-5.694,6.944-11.001,13.704c-1.383,5.869-2.159,12.25-2.159,19.254 c0,52.696,30.343,128.671,92.124,128.671s92.124-75.975,92.124-128.671C302.695,157.56,301.919,151.179,300.536,145.31z  M190.829,239.359h39.482c5.413,0,10.054,3.273,12.075,7.944c-7.29,3.172-18.479,5.216-31.09,5.216 c-13.316,0-25.02-2.284-32.245-5.765C181.194,242.39,185.639,239.359,190.829,239.359z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#543D38"
    },
    d: "M138.187,147.146c-2.742,7.887-6.58,43.683-6.58,43.683l-13.161-7.281l-3.701-48.234 L138.187,147.146z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#543D38"
    },
    d: "M282.954,147.146c2.742,7.887,6.58,43.683,6.58,43.683l13.161-7.281l3.701-48.234L282.954,147.146z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EBF0"
    },
    d: "M361.918,421.141c10.903,0,19.741-8.838,19.741-19.741v-30.562 c0-28.954-22.562-59.864-50.138-68.687l-41.168-13.173c-22.149,16.936-53.802,40.039-79.782,40.039s-57.633-23.103-79.782-40.039 L89.62,302.151c-27.576,8.823-50.138,39.733-50.138,68.687V401.4c0,10.903,8.838,19.741,19.741,19.741H361.918z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545465"
    },
    d: "M223.731,348.757c0,3.619-2.961,6.58-6.58,6.58H203.99c-3.619,0-6.58-2.961-6.58-6.58v-13.161 c0-3.619,2.961-6.58,6.58-6.58h13.161c3.619,0,6.58,2.961,6.58,6.58V348.757z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D0D7DC"
    },
    cx: 210.57,
    cy: 388.239,
    r: 6.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0D7DC"
    },
    d: "M210.57,329.016l-27.456,27.456c-2.859,2.859-7.596,2.487-9.975-0.783l-48.113-66.156 l15.326-15.326c2.475-2.475,6.454-2.579,9.055-0.238L210.57,329.016z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0D7DC"
    },
    d: "M210.57,329.016l27.456,27.456c2.859,2.859,7.596,2.487,9.975-0.783l48.113-66.156l-15.326-15.326 c-2.475-2.475-6.454-2.579-9.055-0.238L210.57,329.016z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#545465"
    },
    points: "219.611,351.636 210.57,355.337 201.53,351.636 197.41,421.141 210.57,421.141  223.731,421.141  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#393950"
    },
    points: "296.114,289.534 361.918,309.275 355.337,329.016 309.275,315.855  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD267"
    },
    points: "353.825,306.847 347.522,304.956 340.879,324.885 347.209,326.694  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD267"
    },
    points: "342.653,303.496 336.349,301.605 329.657,321.679 335.988,323.488  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#393950"
    },
    points: "124.981,289.534 59.178,309.275 65.758,329.016 111.82,315.855  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD267"
    },
    points: "67.27,306.847 73.573,304.956 80.217,324.885 73.886,326.694  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD267"
    },
    points: "78.443,303.496 84.746,301.605 91.438,321.679 85.107,323.488  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EBF0"
    },
    d: "M342.177,85.544c0,36.342-58.922,46.062-131.606,46.062s-131.606-9.72-131.606-46.062 S137.886,0,210.57,0S342.177,49.202,342.177,85.544z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#29394A"
    },
    cx: 210.57,
    cy: 131.606,
    rx: 98.705,
    ry: 26.321
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474F65"
    },
    d: "M111.865,108.39v23.216c21.558-3.809,57.709-6.311,98.705-6.311s77.147,2.502,98.705,6.311V108.39 c-21.557-10.547-57.708-17.473-98.705-17.473S133.424,97.843,111.865,108.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD267"
    },
    d: "M210.571,115.786c-38.534,0-73.388,3.476-98.705,9.088v6.733 c21.558-3.809,57.709-6.311,98.705-6.311c40.996,0,77.147,2.502,98.704,6.311v-6.733 C283.959,119.262,249.104,115.786,210.571,115.786z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#543D38"
    },
    d: "M212.627,233.505c0-8.689-8.431-10.656-13.983-8.55c-10.179,3.861-21.386,14.632-30.845,7.971 c0,0,3.29,13.903,8.841,13.903C187.743,246.828,212.627,248.277,212.627,233.505z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#543D38"
    },
    d: "M209.966,233.505c0-8.689,8.431-10.656,13.983-8.55c10.179,3.861,21.386,14.632,30.845,7.971 c0,0-3.29,13.903-8.841,13.903C234.849,246.828,209.966,248.277,209.966,233.505z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474F65"
    },
    d: "M209.966,71.691c-12.7,0-23.031-10.333-23.031-23.031h6.58c0,9.07,7.38,16.451,16.451,16.451 c9.07,0,16.451-7.38,16.451-16.451h6.58C232.997,61.358,222.666,71.691,209.966,71.691z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 206.676,
    y: 34.677,
    style: {
      fill: "#474F65"
    },
    width: 6.58,
    height: 39.627
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474F65"
    },
    d: "M209.966,36.595c-5.367,0-9.734-4.367-9.734-9.732c0-5.369,4.367-9.736,9.734-9.736 c5.367,0,9.734,4.367,9.734,9.736C219.7,32.229,215.334,36.595,209.966,36.595z M209.966,23.708 c-1.738,0-3.154,1.417-3.154,3.155s1.415,3.152,3.154,3.152c1.738,0,3.154-1.414,3.154-3.152S211.704,23.708,209.966,23.708z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 199.217,
    y: 39.898,
    style: {
      fill: "#474F65"
    },
    width: 21.498,
    height: 6.58
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan2);
export default __webpack_public_path__ + "static/media/man2.47626f6ffc9b33bc8a7313fba4c5a8f0.svg";
export { ForwardRef as ReactComponent };